/**
 * Parse decimal string (accepts both comma and dot) to number.
 */
export function parseDecimal(value: string | number | null | undefined): number {
  if (value === '' || value === null || value === undefined) return 0;
  if (typeof value === 'number') return value;
  const n = parseFloat(String(value).replace(',', '.'));
  return Number.isFinite(n) ? n : 0;
}

/**
 * Format currency in Turkish Lira
 */
export function formatCurrency(amount: number | string | null | undefined): string {
  const numericAmount = typeof amount === 'string' ? parseFloat(amount) : Number(amount);
  if (isNaN(numericAmount) || numericAmount == null) {
    return '₺0,00';
  }
  return new Intl.NumberFormat('tr-TR', {
    style: 'currency',
    currency: 'TRY',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(numericAmount);
}

/**
 * Format price without currency symbol
 */
export function formatPrice(amount: number | string | null | undefined): string {
  const numericAmount = typeof amount === 'string' ? parseFloat(amount) : Number(amount);
  if (isNaN(numericAmount) || numericAmount == null) {
    return '0,00';
  }
  return new Intl.NumberFormat('tr-TR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(numericAmount);
}
